<template>
	<div
		style="background-color: #ffffff"
		class="attend-card-wrapper d-flex align-center px-3 py-3"
	>
		<Avatar class="mr-3 post-preview-card__avatar" :size="50" :avatar="speaker.speaker_logo" />
		<div>
			<div v-if="speaker.speaker_name" class="attend-card-title mb-2">
				{{ speaker.speaker_name }}
			</div>
			<div v-if="speaker.speaker_title" class="attend-card-location mb-2">
				{{ speaker.speaker_title }}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar.vue'

Vue.use(VueScrollTo)

export default {
	name: 'SpeakerCard',
	components: {
		Avatar,
	},
	props: {
		speaker: {
			type: Object,
			default: () => {},
		},
	},
}
</script>

<style lang="scss">
.attend-card {
	&-location {
		color: var(--company-position-large) !important;
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
	}
}
</style>
